import React from 'react';
import './Style.css';

const Home = () => {
    return (
      <div>
        {/* Hero Section */}
        <section className="hero-section pt-5 align-items-center text-center">
          <div className="container">
            <h1 className="hero-subtitle">WINDWARD COVE HOA</h1>
            <h2 className="hero-subtitle">TEXAS</h2>
            <h1 className="hero-title">WELCOME HOME</h1>
            <div className="hero-buttons">
              <a href="/homeowner" className="btn btn-primary btn-lg me-3">HOMEOWNERS PORTAL</a>
            </div>
          </div>
        </section>
      </div>
    );
  };

export default Home;
